import { render } from "./VHeader.vue?vue&type=template&id=7fbb3464&scoped=true"
import script from "./VHeader.vue?vue&type=script&lang=js"
export * from "./VHeader.vue?vue&type=script&lang=js"

import "./VHeader.vue?vue&type=style&index=0&id=7fbb3464&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbb3464"]])

export default __exports__